import ApplicationController from "../../../../javascript/controllers/application_controller";
import { closeModal } from "../modal_controller";

export default class extends ApplicationController {
  static targets = [
    "confirmBtn"
  ];

  static values = {
    selectorId: String,
    isModalTrigger: Boolean,
    icon: String,
    message: String,
    modalTitle: String,
    classes: String,
    toggleMode: Boolean,
    isHtmlMessage: Boolean
  };

  initialize() {
    //? This code executes when the modal is rendered via render_confirm_modal reflex and this.element is modal itself 
    if (!this.hasIsModalTriggerValue) {
      const btnContainer = document.querySelector(`${this.element.dataset['modal-ModalSelectorValue']}-btn`);
      const btn = btnContainer.querySelector("button") || btnContainer.querySelector("a")

      super.removeVanish(btnContainer);
      this.element.querySelector("footer .confirm-modal-button-container").appendChild(btnContainer);
      //? Make sure confirm modal closes when action is clicked
      btn.addEventListener("click", () => closeModal(this.element));
    }
  }

  renderModal(e) {
    if (this?.isModalTriggerValue == false) {
      // If toggle Mode is on, toggles state of the elment that triggered the modal so it won't on next click
      this.updateTriggerForToggleMode();
      return;
    }

    const existingModal = document.getElementById(`${this.selectorIdValue}`);
    // Modal is already rendered on page so open it
    if (existingModal) {
      this.updateTriggerForToggleMode();
      document.body.classList.add("modal-is-open");
      if (existingModal.dataset["modal-ModalStopScrollValue"] == "true") document.body.classList.add("stop-scroll");
      return existingModal.classList.add('is-active');
    }
    // Modal is not rendered on page so render it
    this.stimulate("ApplicationReflex#render_confirm_modal", this.selectorIdValue, this.iconValue, this.messageValue, this.modalTitleValue, this.classesValue, this.isHtmlMessageValue).then(() => {
      this.updateTriggerForToggleMode();
    })
  }

  updateTriggerForToggleMode() {
    if (this?.toggleModeValue) this.isModalTriggerValue = !this.isModalTriggerValue;
  }
}